import React from "react";
import { COMPANY } from "../data/mock";
import { HeroCity } from "./Illustrations";

const Hero = () => {
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="top" className="relative aaa-hero-gradient overflow-hidden">
      {/* soft decorative blob top-left */}
      <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-white/10 blur-2xl" />
      <div className="absolute bottom-0 right-0 w-[60%] h-40 bg-white"
        style={{ clipPath: "polygon(100% 0, 100% 100%, 0 100%)" }} />

      <div className="aaa-container relative pt-36 pb-28 md:pt-44 md:pb-36">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <p className="text-white/80 text-sm mb-4 tracking-wide">{COMPANY.name}</p>
            <h1 className="font-display text-white leading-tight"
              style={{ fontSize: "clamp(2.4rem, 5vw, 3.6rem)", fontWeight: 700 }}>
              {COMPANY.tagline}
              <span className="block font-normal text-white/70" style={{ fontWeight: 400 }}>
                {COMPANY.taglineAccent}
              </span>
            </h1>
            <p className="text-white/85 mt-6 max-w-md leading-relaxed">
              {COMPANY.heroDescription}
            </p>
            <div className="mt-9 flex flex-wrap gap-4">
              <button
                onClick={() => scrollTo("#services")}
                className="bg-white text-[#7a4fa3] px-7 py-3 rounded-md font-medium hover:-translate-y-0.5 hover:shadow-xl transition-all duration-300"
              >
                Explore Products
              </button>
              <button
                onClick={() => scrollTo("#contact")}
                className="border border-white/70 text-white px-7 py-3 rounded-md font-medium hover:bg-white/10 transition-all duration-300"
              >
                Contact Us
              </button>
            </div>
          </div>

          <div className="flex justify-center md:justify-end">
            <HeroCity className="w-full max-w-lg aaa-float" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
